module.exports = __webpack_public_path__ + "static/media/new-message.765be77c.mp3";